$(window).bind("load", initAffix);

$(window).on("resize", function(){
	$(window).off('.affix');
	$('.socialHolder.vertical').removeData('bs.affix').removeClass('affix affix-top affix-bottom');
	initAffix();
});
var initialized = false;
function initAffix(){
	$('.socialHolder.vertical').show();
	var initialOffset = (initialized) ? 0 : 172; //accounts for social link positioning at load time
	var top = $('#login-container-container').outerHeight(true) + $('#Header').outerHeight(true) + $('#header-container-mobile').outerHeight(true) + $('#banner').outerHeight(true) + $('.featuredContent').outerHeight(true);
	var latest = $('#latestContent').outerHeight(true);
	var bottom;
	if($('#footer-info').length > 0) // Old Site
		bottom = $('#footer-info').outerHeight(true) + $('#footer-legal').outerHeight(true);
	else // New Marko Site Design
		bottom =
            $("#newFooterJade").outerHeight(true) +
            $("#newFooterLegal").outerHeight(true);
	
	var content = $('body').outerHeight(true) - top - bottom - latest + initialOffset;
	if(content > bottom){
		$('.socialHolder.vertical').affix({
			offset: {
				top: function() {
					return (
                        $("#login-container-container").outerHeight(true) +
                        $("#Header").outerHeight(true) +
                        $("#header-container-mobile").outerHeight(true) +
                        $("#banner").outerHeight(true) +
                        $(".featuredContent").outerHeight(true)
                    );
				}, 
				bottom: function () {
					if($('#footer-info').length > 0) // Old Site
						return ($('#footer-info').outerHeight(true) + $('#footer-legal').outerHeight(true) + $('#latestContent').outerHeight(true));
					else // New Marko Site Design
						return (
                            $("#newFooterJade").outerHeight(true) +
                            $("#newFooterLegal").outerHeight(true) +
                            $("#latestContent").outerHeight(true)
                        );
					
				}
			}
		});
	} else if(!initialized){
		initialized = true;
		$('.socialHolder.vertical').css({
			position: "absolute",
			left: "15px"
		});
	}
}
//NOTE: onload add footnotes to the print style.
$(function(){
	var footnotes = [];
	$("#articleCopy a").each(function(i,e){
		var url = $(e).attr('href');
		var fIndex = footnotes.indexOf(url);
		if(fIndex < 0){
			footnotes.push(url);
			fIndex = footnotes.length-1;
		}
		$(e).after('<span class="footnotes">[' + (fIndex+1) + ']</span>');
	});
	var footnotesHTML = $('<div class="footnotes"></div>');
	footnotesHTML.append("<h4>Links:</h4>")
	for(var i=0;i<footnotes.length;i++){
		footnotesHTML.append("<div><b>[" + (i+1) + "]</b> " + footnotes[i] + "</div>")
	}
	$("#articleCopy").append(footnotesHTML);
})